import type { PortalSession } from '@/types/api'

const SESSION_KEY = 'the-collected:member-h5:session:v1'

export const readPortalSession = (): PortalSession | null => {
  const raw = localStorage.getItem(SESSION_KEY)
  if (!raw) return null

  try {
    const session = JSON.parse(raw) as PortalSession
    if (!session.accessToken) throw new Error('missing access token')
    return session
  } catch {
    localStorage.removeItem(SESSION_KEY)
    return null
  }
}

export const writePortalSession = (session: PortalSession) => {
  localStorage.setItem(SESSION_KEY, JSON.stringify(session))
}

export const clearPortalSession = () => {
  localStorage.removeItem(SESSION_KEY)
}
